<template>
  <section class="ready-section">
    <div class="cta-box">
      <!-- 顶部小标签 -->
      <div class="tag">RECOVERY SUPPORT - AVAILABLE NOW</div>

      <!-- 主标题 -->
      <h2 class="title">Ready to <span class="gradient">Fight Back?</span></h2>

      <!-- 描述文字 -->
      <p class="description">
        Submit your case today — our specialists review every case within 24 hours<br>
        and contact you with a full assessment and recovery plan. No obligation,<br>
        fully confidential.
      </p>

      <!-- 按钮组 -->
      <div class="buttons">
        <button class="btn-primary">⚡ START INVESTIGATION</button>
        <button class="btn-secondary">▣ View Services</button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ReadyFightSection'
}
</script>

<style scoped>
.ready-section {
  background-color: #070b14;
  /* 深黑蓝背景 */
  padding: 40px 5%;
  /* 上下间距缩小 */
  display: flex;
  justify-content: center;
}

/* 带有边框和圆角的科技感大盒子 */
.cta-box {
  width: 100%;
  max-width: 1400px;
  background: rgba(13, 17, 23, 0.6);
  /* 半透明背景 */
  border: 1px solid rgba(79, 209, 197, 0.2);
  /* 淡淡的青色边框 */
  border-radius: 12px;
  padding: 60px 20px;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
  /* 深色阴影 */
}

/* 小标签：字体小一点 */
.tag {
  color: #4fd1c5;
  font-size: 0.75rem;
  letter-spacing: 2px;
  margin-bottom: 25px;
  font-family: monospace;
}

/* 大标题：字体小一点 */
.title {
  font-size: 2.8rem;
  font-weight: 700;
  margin: 0 0 25px;
  color: #ffffff;
}

/* 渐变色：淡青色到淡蓝色 */
.gradient {
  background: linear-gradient(90deg, #4fd1c5, #8be9fd);
  -webkit-background-clip: text;
  color: transparent;
}

/* 描述：字体小一点 */
.description {
  color: #94a3b8;
  /* 淡灰色 */
  font-size: 1rem;
  /* 缩小字号 */
  line-height: 1.8;
  margin: 0 auto 50px;
}

/* 按钮区 */
.buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
}

/* 主按钮：颜色淡一点 */
.btn-primary {
  background: linear-gradient(90deg, #4fd1c5, #8be9fd);
  /* 淡青色渐变 */
  color: #000;
  border: none;
  padding: 15px 30px;
  font-size: 0.9rem;
  /* 字体小一点 */
  font-weight: 700;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 0 20px rgba(79, 209, 197, 0.3);
}

.btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(79, 209, 197, 0.4);
}

/* 次按钮：淡色边框 */
.btn-secondary {
  background: transparent;
  border: 1px solid rgba(79, 209, 197, 0.5);
  color: #4fd1c5;
  padding: 15px 30px;
  font-size: 0.9rem;
  /* 字体小一点 */
  font-weight: 700;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-secondary:hover {
  background: rgba(79, 209, 197, 0.1);
}

/* 响应式适配：手机端单列居中 */
@media (max-width: 768px) {
  .title {
    font-size: 2.2rem;
  }

  .description br {
    display: none;
    /* 在小屏上去掉强制换行符，让内容自然流淌 */
  }

  .buttons {
    flex-direction: column;
    align-items: center;
  }

  .btn-primary,
  .btn-secondary {
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>